import { render, staticRenderFns } from "./BadgeGlow.vue?vue&type=template&id=abbd8156&"
import script from "./BadgeGlow.vue?vue&type=script&lang=js&"
export * from "./BadgeGlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports